/**
 * d3@3 is an IIFE that assumes `this === window`.
 * Vite/ESM loads it with `this === undefined`, which breaks document/rAF lookups.
 * Run the original source with the IIFE bound to globalThis.
 */
import d3Source from '../../../node_modules/d3/d3.js?raw'

const module = { exports: {} }
const patched = d3Source.replace(/\}\(\);\s*$/, '}.call(globalThis);')
const run = new Function('module', 'exports', `${patched}\nreturn module.exports;`)
const d3 = run(module, module.exports)

export default d3
